/** For fill colours #000000 or #999999 return orange colour */
export const FillOverrides = {
  '#000000': 'orange',
  '#999999': 'orange',
} as const satisfies Record<string, string>;
